enum STATUS {
    new = "new",
    updated = "updated",
    deleted = "deleted",
    unchanged = "unchanged",
    submitted = "submitted",
    graded = "graded",
}

export { STATUS};